module.exports = __webpack_public_path__ + "media/ok.e5d4338b.wav";